import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_CONTRACTOR = gql`
  mutation createOrUpdateContractor($input: CreateOrUpdateContractorInput) {
    createOrUpdateContractor(input: $input) {
      id
      clientId
      name
    }
  }
`;

export const TAG_1099_TRANSACTION = gql`
  mutation tag1099JournalEntries($input: JournalEntryContractorsInput) {
    tag1099JournalEntries(input: $input) {
      journalEntryId
      contractorId
      source1099
    }
  }
`;

export const UNTAG_1099_JOURNAL_ENTRIES = gql`
  mutation untag1099JournalEntries($journalEntryIds: [ID]!) {
    untag1099JournalEntries(journalEntryIds: $journalEntryIds)
  }
`;
